import { render, staticRenderFns } from "./imageAdd.vue?vue&type=template&id=381a6749"
import script from "./imageAdd.vue?vue&type=script&lang=js"
export * from "./imageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports